$.fn.slickYoutube = function (video_ids) {
  new SlickYoutube(this, video_ids);
};

function SlickYoutube (el, video_ids) {
  var that = this,
    defaults = {
      mobile_width: 767,
      ratio: 16 / 9,
      custom_control: 0,
      player: {
        width: 640,
        height: 360,
        playerVars: {
          mute: 0,
          controls: 1,
          loop: 1,
          fs: 0,
          iv_load_policy: 3,
          rel: 0,
          modestbranding: 1,
          start: 1,
          version: 3
        },
      }
    };
  that.options = $.extend({}, defaults, {});
  that.el = $(el);
  that.players = [];
  that.iframes = [];
  that.video_ids = video_ids;
  that.initialize();
}

SlickYoutube.prototype = {
  initialize: function () {
    var that = this;
    that.initPlayers(0);
  },

  initSlider: function () {
    var that = this;
    that.el.on('init', function () {
      that.play(0);
    });
    that.el.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

      var currentPlayer = that.getPlayer(currentSlide),
      nextPlayer = that.getPlayer(nextSlide),
      currentPlayerImage = $(that.getPlayerImage(currentSlide)),
      nextPlayerImage = $(that.getPlayerImage(nextSlide));

      if (currentPlayer !== null) {
        if (currentSlide === nextSlide) {
          if (!currentPlayer.disableAutoplay) {
            currentPlayer.playVideo();
            currentPlayerImage.hide();
          }
        } else {
          currentPlayer.pauseVideo();
          currentPlayerImage.show();
        }
      }

      if (nextPlayer !== null) {
        if (currentSlide !== nextSlide) {
          if (!nextPlayer.disableAutoplay) {
            nextPlayer.playVideo();
            nextPlayerImage.hide();
          }
        }
      }
    });
  },

  initPlayers: function (index) {
    var that = this,
      video_id = that.video_ids[index];
    if (typeof video_id !== 'undefined') {
      var player_container = that.el.find('#' + video_id),
        player = new YT.Player(video_id, that.getOptions(video_id));
      player.disableAutoplay = false;
      that.players[video_id] = player;
      that.iframes.push(player_container);
      if(that.options.custom_control) {
        that.initButton(video_id);
      }
      that.initPlayers(index + 1);
    } else {
      that.initSlider();
    }

  },

  play: function (index) {
    var that = this,
      player = that.getPlayer(index);
    if (player !== null) {
      player.playVideo();
    }
  },

  pause: function (index) {
    var that = this,
      player = that.getPlayer(index);
    if (player !== null) {
      player.pauseVideo();
    }
  },

  getPlayer: function (slideNumber) {
    var that = this,
      playerId = that.el.find('[data-slick-index="' + slideNumber + '"]').find('iframe').attr('id');
    return (typeof playerId !== 'undefined') ? that.players[playerId] : null;
  },

  getPlayerImage: function (slideNumber) {
    var that = this,
      videoImage = that.el.find('[data-slick-index="' + slideNumber + '"]').find('.main-slider__video_preview');
    return (typeof videoImage !== 'undefined') ? videoImage : null;
  },

  getOptions: function (video_id) {
    var
      that = this,
      width = that.options.player.width,
      height = that.options.player.height,
      width_slider = that.el.width();
    if (that.options.mobile_width >= width && width > width_slider) {
      width = width_slider * 0.95;
      height = width / that.options.ratio;
    }

    var playerVars = $.extend(that.options.player.playerVars, {playlist: video_id});
    return $.extend(that.options.player,
      {
        videoId: video_id,
        width: width,
        height: height,
        playerVars: playerVars
      });
  },

  initButton: function (video_id){

    var that = this,
      player = that.players[video_id],
      player_container = that.el.find('#' + video_id),
      sliderWidth = that.el.width(),
      videoWidth = that.el.find('iframe#' + video_id).width(),
      marginLeft = (sliderWidth - videoWidth)/2 + 5,
      videoImage = $(player_container).parent().find('.main-slider__video_preview');
    videoImage.width(videoWidth);
    videoImage.css('margin-left', marginLeft - 5);
    player_container.after('<div id="video-btn-' + video_id + '" class="video-btn video-btn-pause" style="margin-left:' + marginLeft + 'px;"></div>');

    $('#video-btn-' + video_id).on('click', function (e) {
      var btn = e.currentTarget,
        videoImage = $($(btn).next(".main-slider__video_preview"));
      e.stopPropagation();
      if (btn.className.indexOf('video-btn-pause') >= 0) {
        player.pauseVideo();
        player.disableAutoplay = true;
        btn.className ='video-btn video-btn-play';
        videoImage.show()
      } else {
        player.playVideo();
        player.disableAutoplay = false;
        btn.className = 'video-btn video-btn-pause';
        setTimeout(function(){
          videoImage.hide();
        }, 200);
      }
    });
  }
};
